export const API_ERROR = "api_failed";

export const NOTE_MAIN_DATA = "NOTE_Main_data";
export const NOTE_MAIN_DATA_SUCCESS = "NOTE_Main_data_success";
export const NOTE_CLEAR_DATA = "NOTE_Clear_Data";
